import { render, staticRenderFns } from "./JgDialog.vue?vue&type=template&id=505dcacc&scoped=true"
import script from "./JgDialog.vue?vue&type=script&lang=js"
export * from "./JgDialog.vue?vue&type=script&lang=js"
import style0 from "./JgDialog.vue?vue&type=style&index=0&id=505dcacc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505dcacc",
  null
  
)

export default component.exports